import { PRODUCT_LISTING_OVERLAY_HIDDEN, PRODUCT_LISTING_OVERLAY_SHOWING } from '../action-types';

const productListingOverlayShowing = () => ({ type: PRODUCT_LISTING_OVERLAY_SHOWING });
const productListingOverlayHidden = () => ({ type: PRODUCT_LISTING_OVERLAY_HIDDEN });

export default {
  productListingOverlayHidden,
  productListingOverlayShowing,
};
